import config from 'config';

interface ApiEndpoint {
    endpoint: string;
    region: string;
}

interface RestApiConfig {
    [key: string]: ApiEndpoint;
}

export const REST_API_CONF: RestApiConfig = {
    activitiesRDS: {
        endpoint: config.apiGateway.ACTIVITYRDS,
        region: config.apiGateway.REGION
    },
    userBooksRDS: {
        endpoint: config.apiGateway.USERBOOKSRDS,
        region: config.apiGateway.REGION
    },
    booksRDS: {
        endpoint: config.apiGateway.BOOKSRDS,
        region: config.apiGateway.REGION
    },
    tipsByBookRDS: {
        endpoint: config.apiGateway.TIPSRDS,
        region: config.apiGateway.REGION
    },
    assignmentsRDS: {
        endpoint: config.apiGateway.SUBMISSIONSRDS,
        region: config.apiGateway.REGION
    },
    classActivitiesRDS: {
        endpoint: config.apiGateway.CLASSACTIVITYRDS,
        region: config.apiGateway.REGION
    },
    classesRDS: {
        endpoint: config.apiGateway.CLASSRDS,
        region: config.apiGateway.REGION
    },
    classQuizzesRDS: {
        endpoint: config.apiGateway.CLASSQUIZZESRDS,
        region: config.apiGateway.REGION
    },
    differentiationRDS: {
        endpoint: config.apiGateway.DIFFERENTIATIONRDS,
        region: config.apiGateway.REGION
    },
    interactionsRDS: {
        endpoint: config.apiGateway.INTERACTIONRDS,
        region: config.apiGateway.REGION
    },
    notesRDS: {
        endpoint: config.apiGateway.NOTESRDS,
        region: config.apiGateway.REGION
    },
    organizationsRDS: {
        endpoint: config.apiGateway.ORGANIZATIONRDS,
        region: config.apiGateway.REGION
    },
    quizzesRDS: {
        endpoint: config.apiGateway.QUIZZERDS,
        region: config.apiGateway.REGION
    },
    userClassesRDS: {
        endpoint: config.apiGateway.USERCLASSESRDS,
        region: config.apiGateway.REGION
    },
    usersRDS: {
        endpoint: config.apiGateway.USERRDS,
        region: config.apiGateway.REGION
    },
    userPreferenceRDS: {
        endpoint: config.apiGateway.USERS_PREFERENCE_RDS,
        region: config.apiGateway.REGION
    },
    schoology: {
        endpoint: config.apiGateway.SCHOOLOGY,
        region: config.apiGateway.REGION
    },
    schoologyRDS: {
        endpoint: config.apiGateway.SCHOOLOGY_RDS,
        region: config.apiGateway.REGION
    },
    feedbackRDS: {
        endpoint: config.apiGateway.FEEDBACK_RDS,
        region: config.apiGateway.REGION
    },
    logsRDS: {
        endpoint: config.apiGateway.LOGSRDS,
        region: config.apiGateway.REGION
    },
    classlinkRDS: {
        endpoint: config.apiGateway.CLASSLINKRDS,
        region: config.apiGateway.REGION
    },
    emailService: {
        endpoint: config.apiGateway.EMAILSERVICE,
        region: config.apiGateway.REGION
    },
    pastSubmission: {
        endpoint: config.apiGateway.PASTSUBMISSIONS,
        region: config.apiGateway.REGION
    },
    bookUnits: {
        endpoint: config.apiGateway.BOOKUNITS,
        region: config.apiGateway.REGION
    },
    orgPermissions: {
        endpoint: config.apiGateway.ORGPERMISSIONS,
        region: config.apiGateway.REGION
    },
    resources: {
        endpoint: config.apiGateway.RESOURCES,
        region: config.apiGateway.REGION
    },
    keystore: {
        endpoint: config.apiGateway.KEYSTORE,
        region: config.apiGateway.REGION
    },
    clever: {
        endpoint: config.apiGateway.CLEVER,
        region: config.apiGateway.REGION
    },
    bookmarks: {
        endpoint: config.apiGateway.BOOKMARKS,
        region: config.apiGateway.REGION
    },
    chat: {
        endpoint: config.apiGateway.CHAT,
        region: config.apiGateway.REGION
    },
    exams: {
        endpoint: config.apiGateway.EXAMS,
        region: config.apiGateway.REGION
    },
    instructions: {
        endpoint: config.apiGateway.INSTRUCTIONS,
        region: config.apiGateway.REGION
    },
    customAssignments: {
        endpoint: config.apiGateway.ASSIGNMENT,
        region: config.apiGateway.REGION
    },
    googleClassRoom: {
        endpoint: config.apiGateway.GOOGLE_CLASSROOM,
        region: config.apiGateway.REGION
    },
    canvas: {
        endpoint: config.apiGateway.CANVAS,
        region: config.apiGateway.REGION
    },
    story: {
        endpoint: config.apiGateway.STORY,
        region: config.apiGateway.REGION
    },
    apexams: {
        endpoint: config.apiGateway.APEXAMS,
        region: config.apiGateway.REGION
    },
    standardexams: {
        endpoint: config.apiGateway.STANDARDEXAMS,
        region: config.apiGateway.REGION
    },
    howToVideos: {
        endpoint: config.apiGateway.HOWTOVIDEOS,
        region: config.apiGateway.REGION
    },
    notificationRDS: {
        endpoint: config.apiGateway.NOTIFICATION,
        region: config.apiGateway.REGION
    },
    licencesRDS: {
        endpoint: config.apiGateway.LICENCES,
        region: config.apiGateway.REGION
    },
    vocabularyRDS: {
        endpoint: config.apiGateway.VOCABULARY,
        region: config.apiGateway.REGION
    },
    oneway_teacher_video: {
        endpoint: config.apiGateway.ONEWAYTEACHER_VIDEO,
        region: config.apiGateway.REGION
    },
    one_game: {
        endpoint: config.apiGateway.ONEGAME,
        region: config.apiGateway.REGION
    },
    one_game_video: {
        endpoint: config.apiGateway.ONE_GAME_VIDEO,
        region: config.apiGateway.REGION
    },
    oneway_debate: {
        endpoint: config.apiGateway.ONE_WAY_DEBATE,
        region: config.apiGateway.REGION
    },
    firebase: {
        endpoint: config.apiGateway.FIREBASE,
        region: config.apiGateway.REGION
    },
    favourite_video: {
        endpoint: config.apiGateway.FAVOURITE_VIDEO,
        region: config.apiGateway.REGION,
    },
    widgetsRDS: {
        endpoint: config.apiGateway.WIDGETS,
        region: config.apiGateway.REGION,
    },
    super_lesson: {
        endpoint: config.apiGateway.SUPER_LESSON,
        region: config.apiGateway.REGION,
    },
    ebook_highlight: {
        endpoint: config.apiGateway.EBOOK_HIGHLIGHT,
        region: config.apiGateway.REGION,
    },
    non_native_ebook_highlight: {
        endpoint: config.apiGateway.NON_NATIVE_EBOOK_HIGHLIGHT,
        region: config.apiGateway.REGION,
    },
    differentiation_lesson: {
        endpoint: config.apiGateway.DIFFERENTIATION_LESSON,
        region: config.apiGateway.REGION,
    },
    rubric: {
        endpoint: config.apiGateway.RUBRIC,
        region: config.apiGateway.REGION,
    },
    one_game_gallery: {
        endpoint: config.apiGateway.ONE_GAME_GALLERY,
        region: config.apiGateway.REGION,
    },
    one_game_category: {
        endpoint: config.apiGateway.ONE_GAME_CATEGORY,
        region: config.apiGateway.REGION,
    },
    oneway_bingo: {
        endpoint: config.apiGateway.ONE_WAY_BINGO,
        region: config.apiGateway.REGION,
    },
    storyAiConfigRDS: {
        endpoint: config.apiGateway.STORY_AI_CONFIG,
        region: config.apiGateway.REGION,
    },
    whats_new: {
        endpoint: config.apiGateway.WHATS_NEW,
        region: config.apiGateway.REGION,
    },
    studentGroup: {
        endpoint: config.apiGateway.STUDENT_GROUP,
        region: config.apiGateway.REGION,
    },
    lesson_plan: {
        endpoint: config.apiGateway.LESSON_PLAN,
        region: config.apiGateway.REGION,
    },
    permissionsRDS: {
        endpoint: config.apiGateway.PERMISSIONS_RDS,
        region: config.apiGateway.REGION,
    },
};

export const SessionManager = (): string => {
    const session_id = sessionStorage.getItem("session_id");
    if (session_id) {
        return session_id;
    } else {
        const randomSession_id = Math.random().toString(36).substring(7);
        sessionStorage.setItem("session_id", randomSession_id);
        return randomSession_id;
    }
};
